import { useCallback, useEffect, useState } from "react";
import servicesService from "../../../api/servicesService";

export const useProgramacion = () => {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const load = useCallback(async () => {
    try {
      setError("");
      const res = await servicesService.getRecurrenceOverview();
      setOverview(res.data.data || null);
      const created = res.data.data?.sync?.created;
      if (created > 0) {
        setMessage(`${created} servicios del próximo mes se copiaron automáticamente`);
      }
    } catch (err) {
      console.error("Error cargando programación:", err);
      setError("No se pudo cargar la programación recurrente");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const syncNow = useCallback(async () => {
    try {
      setSyncing(true);
      setError("");
      const res = await servicesService.syncRecurrence();
      const created = res.data.data?.created || 0;
      await load();
      setMessage(
        created > 0
          ? `${created} servicios copiados al mes siguiente`
          : "Nada nuevo por copiar: el mes siguiente ya estaba al día"
      );
    } catch (err) {
      console.error("Error sincronizando recurrencia:", err);
      setError("No se pudo sincronizar el mes siguiente");
    } finally {
      setSyncing(false);
    }
  }, [load]);

  return {
    overview,
    loading,
    syncing,
    error,
    message,
    reload: load,
    syncNow,
  };
};
